export default __webpack_public_path__ + "static/media/ADM-logo.e7137246.png";